import { Vendor } from 'api/vendors'
import EditorTabs from 'components/DocumentDetail/Editor/EditorTabs'
import Base from 'components/DocumentDetail/Editor/Invoice/Base'
import Items from 'components/DocumentDetail/Editor/Invoice/Items'
import { DocumentInvoiceV2 } from 'entities/DocumentsInvoiceV2'

interface Props {
  docDetail: DocumentInvoiceV2
  vendors: Vendor[]
}

function Invoice({ docDetail, vendors }: Props) {
  return (
    <EditorTabs labels={['基本情報', '品目情報']}>
      <Base docDetail={docDetail} vendors={vendors} />
      <Items docDetail={docDetail} />
    </EditorTabs>
  )
}

export default Invoice
